import getAuth0 from './client';

export default async function isAuthenticated() {
  try {
    const auth0 = await getAuth0();

    return auth0.isAuthenticated();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('err', err);

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth0/is-authenticated.js